module.exports = __webpack_public_path__ + "static/media/crossword-social-image.0b5ecfc4.png";